import axios from 'axios';
import { API_HOST } from './config';

const instance = axios.create({
    baseURL: API_HOST
});

instance.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response.status === 401) {
        window.location = "/login";
        return
    }
    return Promise.reject(error)
});

export default instance;